import React, { useState, useEffect } from "react";
import {
  createBranch,
  updateBranch
} from "../../../Utility/Api";
import { toast } from "react-toastify";

export const EditBranchs = ({
  showModal,
  setShowModal,
  fetchBranchs,
  selectedBranch,
  isAddMode,
}) => {
  const [formData, setFormData] = useState({
    title: "",
    country: ""
  });
  const [errors, setErrors] = useState({});
  const [buttondisable, setbuttondisable] = useState(false)

  useEffect(() => {
    if (isAddMode) {
      setFormData({
        title: "",
        country: ""
      });
    } else {
      setFormData({
        title: selectedBranch.title || "",
        country: selectedBranch.country || "",

      });
    }
  }, [selectedBranch]);



  const handleChange = (e) => {
    const { title, value } = e.target;
    setFormData({
      ...formData,
      [title]: value,
    });
    setErrors((prev) => ({
      ...prev,
      [title]: "",
    }));
  };
  const handleclear = () => {
    setShowModal(false);
    setErrors({
      title: "",
      country: ""
    })
    setFormData({
      title: "",
      country: ""
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setbuttondisable(true)
    const validationErrors = {};

    if (!formData.title) {
      validationErrors.title = "Branch title is required.";
    }


    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);

      return;
    }

    // Prepare the payload to be sent in the API request
    const payload = {
      country: formData.country,
      title: formData.title,
    };
    console.log("Submitting payload:", payload);

    try {
      if (isAddMode) {
        await createBranch(payload); // Create a new brand
        toast.success("Branch Added successfully");
        setbuttondisable(false)
      } else {
        await updateBranch(selectedBranch.id, payload); // Update the existing brand
        toast.success("Branch Updated successfully");
        setbuttondisable(false)
      }
      setbuttondisable(false)
      handleclear();
      setShowModal(false); // Close the modal
      fetchBranchs(); // Refresh the list of brands
    } catch (error) {
      console.error(
        "Error handling brand data:",
        error.response ? error.response.data : error.message
      );
      toast.error("Error handling brand data");
    }
  };

  return (
    <>
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h5 className="modal-title">
                  {isAddMode ? "Add Branch" : "Edit Branch"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => handleclear()}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  <div className="form-group mb-3 d-flex align-items-center ">
                    <label className="col-3 mb-0 text-normal">Branch Name</label>
                    <div className="col-8">
                      <input
                        type="text"
                        title="title"
                        value={formData.title}
                        onChange={handleChange}
                        className="form-control"

                      />
                      {errors.title && (
                        <small className="text-danger">{errors.title}</small>
                      )}
                    </div>
                  </div>
                  <div className="form-group mb-3 d-flex align-items-center ">
                    <label className="col-3 mb-0 text-normal">Country</label>
                    <div className="col-8">
                      <input
                        type="text"
                        title="country"
                        value={formData.country}
                        onChange={handleChange}
                        className="form-control"
                      />
                      {errors.country && (
                        <small className="text-danger">{errors.country}</small>
                      )}
                    </div>
                  </div>

                  <div className="mt-5 ">
                    <button disabled={buttondisable}
                      type="submit"
                      className="btn btn-success me-2 float-end"
                    >
                      {isAddMode ? "Add Branch" : "Update Branch"}
                    </button>
                    {/* &nbsp; */}
                    <button
                      type="button"
                      className="btn btn-secondary me-2 float-end"
                      onClick={() => handleclear()}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
